import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Create digital signage with Canva"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.airsquirrels.com/ditto/how-to-canva/source/portal",
      target: "_blank",
      rel: "noreferrer noopener"
    }, "Get step-by-step instructions"),
    /*#__PURE__*/_createTextVNode(" to create digital signage using Canva designs.")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Edit Canva Design", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Edit this signage item in Canva. Then share it with Ditto. All signage items with the same Canva design ID will be updated in your signage lists.", -1)
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.layoutDataEdit
  }, {
    default: _withCtx(() => [
      (_ctx.isCreatingNewSignageItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  target: "blank",
                  href: _ctx.canvaLink,
                  class: "link"
                }, "Edit this signage item in Canva.", 8, _hoisted_8)
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["model"]))
}